/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { Link } from "react-router-dom";
import { ReactComponent as ClarityLogoWhite } from "cms/assets/images/claritybc-logo-white.svg";

const MinimalHeader = () => {

    return (
        <header className="header minimal">
            <Link to='/' className='clarity-logo'>
                <ClarityLogoWhite alt='clarity-logo' />
            </Link>
        </header>
    );
};

export { MinimalHeader };
